module.exports = __webpack_public_path__ + "media/images/ecalls/fausto_botelho_bitcoin-2c4ca380c7192c2cecce4eba88fe83af.png";